
export {ClayModalProvider,
Modal,
useModal,
Context,
Body,
Header,
Item,
ItemGroup,
Subtitle,
SubtitleSection,
Title,
TitleIndicator,
TitleSection} from '../../../frontend-js-clay-web/__liferay__/exports/@clayui$modal.js';
import __x__ from '../../../frontend-js-clay-web/__liferay__/exports/@clayui$modal.js';export default __x__;